import React from "react";
import ErrorModal from "~/components/modals/error/ErrorModal";

interface Props {
  isOpened: boolean;
  message: string;
  onClose: () => void;
  onConfirm: () => void;
}

const AppointmentErrorModal: React.FC<Props> = ({
  isOpened,
  onClose,
  onConfirm,
  message,
}) => {
  return (
    <ErrorModal isOpened={isOpened} onClose={onClose} onConfirm={onConfirm}>
      <p className="">{message}</p>
    </ErrorModal>
  );
};

export default AppointmentErrorModal;
